<!-- src/App.vue -->
<template>
  <div class="app-container">
    <BulletScreen />
    <router-view />
  </div>
</template>

<script setup>
import BulletScreen from '@/components/BulletScreen.vue'
</script>

<style scoped>
.app-container {
  min-height: 100vh;
  background-color: #fff;
  position: relative;
  margin: 0 auto;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.05);
  overflow-x: hidden;
}
</style>

<style>
html, body {
  margin: 0;
  padding: 0;
  height: 100%;
  overflow-x: hidden;
}

.el-loading-mask {
  transition: opacity 1s ease !important; /* 延长淡入淡出时间 */
}
</style>